import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { IconTimeline } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';
import { isDevFeatureEnabled } from '../../../../constants/dev';
import { latestSpansSelector } from '../../../../redux/modules/datapoints/selector';
import { ValidationTelemetryModal } from './ValidationTelemetryModal';

export const ValidationTelemetryButton = () => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const spans = useSelector(latestSpansSelector);

  if (!isDevFeatureEnabled('validate-explain')) {
    return null;
  }

  return (
    <>
      <Tooltip
        title={intl.formatMessage({
          id: 'features.validationTelemetry.title',
        })}
      >
        <IconButton
          size="medium"
          color="secondary"
          onClick={() => setOpen(true)}
          disabled={!spans?.length}
        >
          <SvgIcon fontSize="medium">
            <IconTimeline />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <ValidationTelemetryModal
        open={open}
        onClose={() => setOpen(false)}
        spans={spans}
      />
    </>
  );
};
